import type { ReactNode } from 'react';
import { vesselAlertSentLabel, vesselAlertTeamName } from '../model/vesselAlerts';
import type { VesselAlert } from '../types/vesselChanges';
import { FOCUS_RING } from './rowStyles';

/** Line 1 of an alert row: what it is about, a "No employee" label for jobs without one, and when it was sent. */
export const AlertRowTitle = ({ alert, children }: { alert: VesselAlert; children: ReactNode }) => (
  <span className="flex items-baseline gap-2">
    <span className="min-w-0 truncate text-[13px] font-semibold text-slate-900">{children}</span>
    {alert.unassigned && (
      <span className="shrink-0 rounded bg-slate-100 px-1.5 text-[10px] font-medium text-slate-600">No employee</span>
    )}
    <span className="ml-auto shrink-0 text-[11px] tabular-nums text-slate-400">{vesselAlertSentLabel(alert.sentAt)}</span>
  </span>
);

/** Line 2: plain muted details joined by " · ", with the team member's name for an escalated alert. */
export const AlertRowDetails = ({ alert, parts }: { alert: VesselAlert; parts: string[] }) => {
  const teamName = vesselAlertTeamName(alert);
  const text = [...parts, teamName].filter(Boolean).join(' · ');
  return <span className="mt-0.5 block truncate text-xs text-slate-600">{text}</span>;
};

/** A quiet text action under a row ("Open job", "Not this vessel"). */
export const AlertActionButton = ({ label, onClick, disabled }: { label: string; onClick: () => void; disabled?: boolean }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={`rounded px-1 py-0.5 text-[11px] font-medium text-blue-700 hover:bg-slate-100 hover:underline disabled:opacity-50 ${FOCUS_RING}`}
  >
    {label}
  </button>
);
